var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddCart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M1.753 0a.75.75 0 1 0 0 1.5H3.13c.364 0 .667.252.736.61l.148.773v.007l1.614 8.468A3.254 3.254 0 0 0 8.822 14h9.363c1.558 0 2.9-1.11 3.192-2.642L22.99 2.89a.75.75 0 0 0-.737-.89H5.373l-.032-.17A2.26 2.26 0 0 0 3.13 0zm11.5 5a.75.75 0 0 1 .75.75V7h1.25a.75.75 0 1 1 0 1.5h-1.25v1.25a.75.75 0 1 1-1.5 0V8.5h-1.25a.75.75 0 1 1 0-1.5h1.25V5.75a.75.75 0 0 1 .75-.75m-3.25 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
})));
export default SvgAddCart;